import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function ExpertSection() {
  return <Section bg="cream-dark" data-id="element-204">
      <div className="max-w-md mx-auto" data-id="element-205">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-4 lg:gap-6 items-center" data-id="element-206">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative max-w-[220px] mx-auto lg:max-w-none" data-id="element-207">
            <div className="absolute -inset-2 bg-gold/10 rounded-2xl blur-xl -z-10" data-id="element-208" />
            <div className="aspect-[3/4] rounded-xl overflow-hidden shadow-xl relative" data-id="element-209">
              <div className="absolute inset-0 bg-olive/10 mix-blend-multiply z-10" data-id="element-210" />
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1000&auto=format&fit=crop" alt="Dra. Florencia Bertotto" className="w-full h-full object-cover grayscale-[20%]" data-id="element-211" />
            </div>

            {/* Floating Credentials */}
            <div className="absolute -bottom-3 -right-3 lg:-right-6 glass-card p-3 rounded-xl max-w-[150px] z-20" data-id="element-212">
              <p className="font-serif italic text-xl text-olive mb-0.5" data-id="element-213">12+</p>
              <p className="text-[10px] uppercase tracking-widest text-charcoal-light font-medium leading-tight" data-id="element-214">
                Años acompañando mujeres argentinas
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4" data-id="element-215">
            <div data-id="element-216">
              <p className="text-[10px] font-medium tracking-[0.2em] text-gold uppercase mb-2" data-id="element-217">
                La Creadora
              </p>
              <h2 className="text-2xl md:text-3xl font-serif text-charcoal mb-1" data-id="element-218">
                Dra. Florencia Bertotto
              </h2>
              <p className="text-sm text-olive font-light tracking-wide" data-id="element-219">
                Coach en Wellaging y Bienestar Integral
              </p>
            </div>

            <div className="space-y-3 text-charcoal-light font-light text-sm leading-relaxed" data-id="element-220">
              <p data-id="element-221">
                <span className="text-xl font-serif italic text-gold leading-none mr-1" data-id="element-222">
                  "
                </span>
                Durante años vi en mi consultorio a mujeres brillantes y
                exitosas que llegaban a los 45 años sintiéndose agotadas y
                resignadas a que 'así es envejecer'.
              </p>
              <p data-id="element-223">
                Por eso creé el Método Wellaging 360°. Para traducir la ciencia
                de longevidad en pasos simples, aplicables a la vida real de una
                mujer argentina.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 pt-4 border-t border-gold/20" data-id="element-224">
              <div data-id="element-225">
                <p className="text-[10px] uppercase tracking-widest text-charcoal/40 mb-1" data-id="element-226">
                  Formación
                </p>
                <p className="text-xs text-charcoal font-medium" data-id="element-227">
                  Nutrición Funcional
                </p>
              </div>
              <div data-id="element-228">
                <p className="text-[10px] uppercase tracking-widest text-charcoal/40 mb-1" data-id="element-229">
                  Especialidad
                </p>
                <p className="text-xs text-charcoal font-medium" data-id="element-230">
                  Coaching de Hábitos
                </p>
              </div>
            </div>

            <div className="pt-3 flex items-center gap-3" data-id="element-231">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_of_Florencia.svg/1200px-Stylized_signature_of_Florencia.svg.png" alt="Firma Florencia" className="h-7 opacity-40 grayscale" onError={e => e.currentTarget.style.display = 'none'} data-id="element-232" />
              <p className="font-serif italic text-charcoal-light text-xs" data-id="element-233">
                "Tu vitalidad no tiene fecha de vencimiento."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </Section>;
}